export const ERROR_TITLE = 'Something went wrong';

export const ERROR_DESCRIPTION =
	'We have received a report of this error and are working to fix it as soon as possible. Sorry for the inconvenience. Try reloading this page.';

export const EXPIRATION_DATE_BEFORE_SCHEDULE_DATE_ERROR_CODE = 1913;
export const CANNOT_ACTIVATE_CAMPAIGN_WITH_ALL_CTAS_ARCHIVED = 1933;
export const CANNOT_ACTIVATE_CAMPAIGN_FOR_NON_PREMIUM_ENTITY = 1934;
export const REPEATED_CAMPAIGN_NAME_ERROR_CODE = 104;
/** Backend: NICHE_EXTERNAL_API_TRANSFORM_VOICE_USER_IMPOSSIBLE */
export const VOICE_TRANSFORM_USER_IMPOSSIBLE_ERROR_CODE = 8009;
